import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class SubjectInfoApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'subject-info'
    }




}